/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const PanelIcon = ({ width = 24, height = 24, hidden = false, title = 'Panel' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <rect height="3" rx="1" ry="1" width="16" x="10" y="30" />
    <rect height="3" rx="1" ry="1" width="16" x="10" y="8" />
    <rect height="3" rx="1" ry="1" width="16" x="10" y="14" />
    <path
      d="M30.5 2h-25A1.5 1.5 0 0 0 4 3.5V34h2v-8h24v8h2V3.5A1.5 1.5 0 0 0 30.5 2ZM30 22H6V4h24Z"
    />
  </svg>`;
};
